export const state = {
  users: {},
  authPage: undefined
}
